module.exports = require("core-js/modules/es.array.reverse.js");